
import startPoint from "../assets/onlineMap/poi/startPoint.png";
import endPoint from "../assets/onlineMap/poi/endPoint.png";
import viaPoint from "../assets/onlineMap/poi/viaPoint.png";
import busstation from "../assets/onlineMap/poi/busstation.png";
import subwaystation from "../assets/onlineMap/poi/subwaystation.png";
import poi_1 from "../assets/onlineMap/poi/1.png";
import poi_1_select from "../assets/onlineMap/poi/1_c.png";
import poi_2 from "../assets/onlineMap/poi/2.png";
import poi_2_select from "../assets/onlineMap/poi/2_c.png";
import poi_3 from "../assets/onlineMap/poi/3.png";
import poi_3_select from "../assets/onlineMap/poi/3_c.png";
import poi_4 from "../assets/onlineMap/poi/4.png";
import poi_4_select from "../assets/onlineMap/poi/4_c.png";
import poi_5 from "../assets/onlineMap/poi/5.png";
import poi_5_select from "../assets/onlineMap/poi/5_c.png";
import poi_6 from "../assets/onlineMap/poi/6.png";
import poi_6_select from "../assets/onlineMap/poi/6_c.png";
import poi_7 from "../assets/onlineMap/poi/7.png";
import poi_7_select from "../assets/onlineMap/poi/7_c.png";
import poi_8 from "../assets/onlineMap/poi/8.png";
import poi_8_select from "../assets/onlineMap/poi/8_c.png";
import poi_9 from "../assets/onlineMap/poi/9.png";
import poi_9_select from "../assets/onlineMap/poi/9_c.png";
import poi_10 from "../assets/onlineMap/poi/10.png";
import poi_10_select from "../assets/onlineMap/poi/10_c.png";
import draw_marker from "../assets/onlineMap/poi/draw_marker.png";
import collect_poi_marker from "../assets/onlineMap/poi/collect_poi_marker.png";




export class AssetsConfig
{   
    constructor()
    {   

    }

    static getPOIIcon(poiIndex,selectedStatus)
    {   
        let iconSrc=null;
        if(poiIndex<0 )return iconSrc;

        if(poiIndex==1)
        {   
            if(!selectedStatus)
            {   
                iconSrc=poi_1;
            }   
            else
            {
                iconSrc=poi_1_select;
            }
        }
        else if(poiIndex==2)
        {
            if(!selectedStatus)
            {   
                iconSrc=poi_2;
            }   
            else
            {
                iconSrc=poi_2_select;
            }
        }
        else if(poiIndex==3)
        {
            if(!selectedStatus)
            {   
                iconSrc=poi_3;
            }   
            else
            {
                iconSrc=poi_3_select;
            }
        }
        else if(poiIndex==4)
        {
            if(!selectedStatus)
            {   
                iconSrc=poi_4;
            }   
            else
            {
                iconSrc=poi_4_select;
            }
        }
        else if(poiIndex==5)
        {
            if(!selectedStatus)
            {   
                iconSrc=poi_5;
            }   
            else
            {
                iconSrc=poi_5_select;
            }
        }
        else if(poiIndex==6)
        {
            if(!selectedStatus)
            {   
                iconSrc=poi_6;
            }   
            else
            {
                iconSrc=poi_6_select;
            }
        }
        else if(poiIndex==7)
        {
            if(!selectedStatus)
            {   
                iconSrc=poi_7;
            }   
            else
            {
                iconSrc=poi_7_select;
            }
        }
        else if(poiIndex==8)
        {
            if(!selectedStatus)
            {   
                iconSrc=poi_8;
            }   
            else
            {
                iconSrc=poi_8_select;
            }
        }
        else if(poiIndex==9)
        {
            if(!selectedStatus)
            {   
                iconSrc=poi_9;
            }   
            else
            {
                iconSrc=poi_9_select;
            }
        }
        else if(poiIndex==10)
        {
            if(!selectedStatus)
            {   
                iconSrc=poi_10;
            }   
            else
            {
                iconSrc=poi_10_select;
            }
        }

        return iconSrc;
    }

    static getDrawMarkerIcon()
    {   
        let iconSrc=draw_marker;

        return iconSrc;
    }

    static getCollectPoiMarkerIcon()
    {   
        let iconSrc=collect_poi_marker;
        return iconSrc;
    }
    

}


AssetsConfig.route_startPoint=startPoint;
AssetsConfig.route_endPoint=endPoint;
AssetsConfig.route_viaPoint=viaPoint;
AssetsConfig.busstation=busstation;
AssetsConfig.subwaystation=subwaystation;